export class MediaSelector {
  constructor(container) {
    this.container = container;
    this.mediaSelect = container.querySelector('[data-media-selector]');
    if (!this.mediaSelect) {
      console.warn('Media selector not found');
      return;
    }
    this.countryCode = this.mediaSelect.getAttribute('data-country-code');
    this.init();
  }

  async init() {
    try {
      await this.fetchMediaChannels();
      this.setupEventListeners();
    } catch (error) {
      console.error('Error initializing media selector:', error);
    }
  }

  setupEventListeners() {
    this.mediaSelect.addEventListener('change', () => {
      if (this.mediaSelect.value) {
        this.mediaSelect.classList.add('has-value');
        if(window?.checkout) {
          if(typeof window.checkout?.mediaTarget !== 'undefined') {
            window.checkout.mediaTarget = this.mediaSelect.value || "";
          }
        }
      } else {
        this.mediaSelect.classList.remove('has-value');
        if(window?.checkout) {
          if(window.checkout?.mediaTarget) window.checkout.mediaTarget = null;
        }
      }
    });
  }

  async fetchMediaChannels() {
    if (!this.countryCode) {
      console.warn('Country code not found');
      return;
    }

    try {
      const response = await fetch(
        `https://wellvita-api.netlify.app/.netlify/functions/mediaChannelSelectors?country=${this.countryCode}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const mediaData = data?.ArrayOfstring || [];

      if (mediaData && Array.isArray(mediaData)) {
        this.populateOptions(mediaData);
      } else {
        console.warn('Invalid data format received from API');
      }
    } catch (error) {
      console.error('Error fetching media channels:', error);
    }
  }

  populateOptions(options) {
    const placeholder = this.mediaSelect.querySelector('option[disabled]');
    this.mediaSelect.innerHTML = '';
    if (placeholder) {
      this.mediaSelect.appendChild(placeholder);
    }

    // Add new options
    options.forEach(option => {
      const optionElement = document.createElement('option');
      optionElement.value = option.value || option.name || option;
      optionElement.textContent = option.label || option.name || option;
      this.mediaSelect.appendChild(optionElement);
    });
  }

  getValue() {
    return this.mediaSelect.value;
  }
}
